import React from "react";
import "./videoArea.css";
import "../../css/sharedStyles.css";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import MoreButton from "../moreButton/MoreButton.js";
import {getVideoListData} from "../includes/axios/getVideoListData.js";


var VideoArea = class VideoArea extends React.Component{
  constructor(props) {
      super(props);
  }  

  componentDidUpdate(prevProps){
    //if the main characters name value has changed in Redux, update this component
    if(prevProps.characterInfo.character != this.props.characterInfo.character){
        var character = this.props.characterInfo.character;
        getVideoListData(character,this.props.changeVideos,this.props.showVideos);
    }//end if(prevProps)
    // var characterArray = this.props.characterInfo.relatedCharacters;
    // var finishTest = characterArray.length -1;

    }

    triggerVideoPopup(videoID){
        this.props.changeVideoPopupVisibility(true);
        this.props.changeSelectedVideo(videoID);  
    }
    
    render() {
        const routeBase = localStorage.getItem("routeBase"); 

        if(this.props.videoInfo.videosReadyToShow === true){
            
            return (
            <div className = "VideoAreaContainer">
                <div className="videoArea">
                {
                this.props.videoInfo.videosArray.map(function(item,index){
                    if(index <= 2){
                        var videoID = this.props.videoInfo.videosArray[index][0];
                        return <Link to={routeBase + "/videosPage"} key={index}>
                            <div className="videoContainer"
                                onClick = {()=>{this.triggerVideoPopup(videoID)}}
                            >
                                <div className="imageHolder">
                                    <img src={this.props.videoInfo.videosArray[index][3]} />
                                </div>
                                <div className="title">{this.props.videoInfo.videosArray[index][1]}</div>
                            </div>                       
                        </Link>
                    }//end if()
                },this)    
                }
                
                </div> {/* end VideoArea */}

                <Link to={routeBase + "/videosPage"}>
                    <MoreButton margin = {"5px 0 20px 20px"}/>
                </Link> 




            </div>// End VideoAreaContainer
            ); //end return()
        }//end if()
        else{
            return (
                <div className = 'loadingAnimation'>We're still loading this shit</div>
            )
        }






    }//end render()
  }//end class()

export default VideoArea;


// WEBPACK FOOTER //
// ./src/components/videoArchiveArea/VideoAreaContainer.js